import { Typography, useTheme } from '@mui/material';
import React from 'react';

enum ColorValue {
  primary = 'primary',
  secondary = 'secondary',
  black = 'black',
  white = 'white',
  default = 'default',
}

type ColorValueType = keyof typeof ColorValue;
type TextAlign = 'left' | 'center' | 'right';

type Props = {
  children?: React.ReactNode;
  align?: TextAlign;
  color?: ColorValueType;
  styles?: Pick<React.CSSProperties, 'lineHeight' | 'color' | 'fontSize' | 'fontWeight' | 'margin'>;
  id?: string;
};

function UiSubHeading({ color, align, styles, children, ...rest }: Props) {
  const theme = useTheme();

  function getColor(color?: ColorValueType) {
    if (styles?.color) {
      return styles.color;
    }

    switch (color) {
      case ColorValue.default:
        return theme.bodyColor;
      case ColorValue.primary:
        return theme.palette.themeColor.main;
      case ColorValue.secondary:
        return theme.palette.themeColor.contrastText;
      case ColorValue.black:
        return theme.palette.black.main;
      case ColorValue.white:
        return theme.palette.white.main;
    }
    return;
  }

  return (
    <Typography
      component="div"
      sx={{
        fontSize: '24px',
        fontWeight: '600',
        ...styles,
        textAlign: align,
        color: getColor(color),
      }}
      className="ui-typography-subheading"
      {...rest}
    >
      {children}
    </Typography>
  );
}

export default UiSubHeading;
